import { render } from "./CreateAssignmentModal.vue?vue&type=template&id=77c4d87c"
import script from "./CreateAssignmentModal.vue?vue&type=script&lang=js"
export * from "./CreateAssignmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__